"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileNoteDto = instanceOfProfileNoteDto;
exports.ProfileNoteDtoFromJSON = ProfileNoteDtoFromJSON;
exports.ProfileNoteDtoFromJSONTyped = ProfileNoteDtoFromJSONTyped;
exports.ProfileNoteDtoToJSON = ProfileNoteDtoToJSON;
exports.ProfileNoteDtoToJSONTyped = ProfileNoteDtoToJSONTyped;
const NoteAttachmentDto_1 = require("./NoteAttachmentDto");
/**
 * Check if a given object implements the ProfileNoteDto interface.
 */
function instanceOfProfileNoteDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('note' in value) || value['note'] === undefined)
        return false;
    if (!('author' in value) || value['author'] === undefined)
        return false;
    if (!('authorId' in value) || value['authorId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('attachments' in value) || value['attachments'] === undefined)
        return false;
    if (!('profile' in value) || value['profile'] === undefined)
        return false;
    return true;
}
function ProfileNoteDtoFromJSON(json) {
    return ProfileNoteDtoFromJSONTyped(json, false);
}
function ProfileNoteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'note': json['note'],
        'author': json['author'],
        'authorId': json['authorId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'attachments': (json['attachments'].map(NoteAttachmentDto_1.NoteAttachmentDtoFromJSON)),
        'profile': json['profile'],
    };
}
function ProfileNoteDtoToJSON(json) {
    return ProfileNoteDtoToJSONTyped(json, false);
}
function ProfileNoteDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'note': value['note'],
        'author': value['author'],
        'authorId': value['authorId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'attachments': (value['attachments'].map(NoteAttachmentDto_1.NoteAttachmentDtoToJSON)),
        'profile': value['profile'],
    };
}
//# sourceMappingURL=ProfileNoteDto.js.map